<form [formGroup]="form">
  <ion-row>
    @for (val of HEADERS; track val) {
      <ion-col size="1.4" id="container">
        {{ val }}
      </ion-col>
    }
  </ion-row>
  <ng-container formArrayName="customerLocationDetails">
    @for (rowData of TABLE_DATA; track rowData; let i = $index) {
      <form [formGroupName]="i">
        <ion-row>
          @for (val of rowData.rowValues; track val) {
            <ion-col size="1.4" id="container">
              @if (!!val.label && !val.formControl) {
                <div>{{ val.label }}</div>
              }
              @if (!val.label && !!val.formControl) {
                <ng-select
                  appearance="outline"
                  id="dropdown"
                  [formControlName]="val.formControl"
                  [searchable]="false"
                  [clearable]="false"
                >
                  @for (option of OPTIONS; track option) {
                    <ng-option [value]="option.value">
                      <div>
                        {{ option.label }}
                      </div>
                    </ng-option>
                  }
                </ng-select>
              }
            </ion-col>
          }
        </ion-row>
      </form>
    }
  </ng-container>
</form>
